import { Answer } from 'mytours-read-api-typescript'

// Keyboard predictive text appends a trailing space, so whitespace around either side must not count
const normalize = (text: string): string => text.trim().toLowerCase()

export const isFreeTextAnswerCorrect = (answers: Answer[], given: string): boolean =>
	answers.some(answer => !!answer.answer_text && normalize(answer.answer_text) === normalize(given))
